export default () => ({
  Checkout__page: {
    display: 'flex'
  }
})
